"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    buildHotelDetailURL: ()=>buildHotelDetailURL
});
const external_date_fns_namespaceObject = require("date-fns");
const buildHotelDetailURL = (args, hotel, queryString)=>{
    const hotelDetailsURL = hotel?.hotelDetailsURL || '';
    if (hotelDetailsURL) {
        const url = new URL(hotelDetailsURL);
        const pathname = url.pathname;
        const search = url.search;
        return `${pathname}${search}`;
    }
    const isExpressDeal = 'SOPQ' === hotel.hotelType;
    const hotetIdParams = isExpressDeal ? `express/${hotel.location?.cityId}/${hotel.pclnId}` : hotel.hotelId;
    let baseURL = `/relax/at/${hotetIdParams}`;
    if (args?.['check-in'] && args?.['check-out']) baseURL += `/from/${args?.['check-in']}/to/${args?.['check-out']}`;
    else if (isExpressDeal) {
        const today = new Date();
        const tomorrow = (0, external_date_fns_namespaceObject.addDays)(today, 1);
        const defaultCheckIn = (0, external_date_fns_namespaceObject.format)(today, 'yyyyMMdd');
        const defaultCheckOut = (0, external_date_fns_namespaceObject.format)(tomorrow, 'yyyyMMdd');
        baseURL += `/from/${defaultCheckIn}/to/${defaultCheckOut}`;
    }
    if (args?.rooms) baseURL += `/rooms/${args?.rooms}`;
    if (args?.['adult-occ']) baseURL += `/adults/${args?.['adult-occ']}`;
    if (args?.['child-occ']) {
        const childOcc = args?.['child-occ'];
        const childPathParams = childOcc.split(',').reduce((res, child)=>{
            const age = child?.split('-')?.[1];
            if (age) res.push(age);
            return res;
        }, [])?.join(',');
        if (childPathParams) baseURL += `/children/${childPathParams}`;
    }
    return `${baseURL}${queryString}`;
};
exports.buildHotelDetailURL = __webpack_exports__.buildHotelDetailURL;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "buildHotelDetailURL"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
